import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "reactstrap";

import usePlanFeatures from "../../../hooks/usePlanFeatures";
import { userHasAnyRole } from "../../../services/authService";

/**
 * D28 trial expiry warning — shown to owners when ≤2 days remain (doc 10 § 2).
 */
const TrialExpiryBanner = () => {
  const { t } = useTranslation();
  const { isTrial, trialDaysRemaining, isLoading } = usePlanFeatures();

  if (isLoading || !userHasAnyRole(["owner"])) {
    return null;
  }

  if (!isTrial || trialDaysRemaining === null || trialDaysRemaining > 2) {
    return null;
  }

  const daysLabel =
    trialDaysRemaining <= 0
      ? t("plan.trial.banner.expiresToday")
      : trialDaysRemaining === 1
        ? t("plan.trial.banner.expiresTomorrow")
        : t("plan.trial.banner.expiresInDays", { days: trialDaysRemaining });

  return (
    <Alert color="warning" className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4">
      <div className="d-flex align-items-start gap-2">
        <i className="ri-timer-flash-line fs-4 mt-1" aria-hidden />
        <div>
          <strong className="d-block">{t("plan.trial.banner.title")}</strong>
          <span className="text-body">{daysLabel}</span>
          <span className="d-block text-muted small mt-1">
            {t("plan.trial.banner.description")}
          </span>
        </div>
      </div>
      <Button
        tag={Link}
        to="/settings/subscription"
        color="warning"
        size="sm"
        className="flex-shrink-0"
      >
        {t("plan.trial.banner.cta")}
      </Button>
    </Alert>
  );
};

export default TrialExpiryBanner;
